import { signUpActionTypes } from '~/store/legacy/actions/signUpActions.js';

const initState = {
  sentCodeToEmail: '',
  sentCode: false,
  verified: false,
  userInputtedCode: '',
};

const SignupReducer = (state = initState, action) => {
  switch (action.type) {
    case signUpActionTypes.sentCodeStart:
      return {
        ...state,
        ...{
          sentCodeToEmail: action.email,
        },
      };

    case signUpActionTypes.sentCodeSuccess:
      return {
        ...state,
        ...{
          sentCodeToEmail: action.email,
          sentCode: true,
        },
      };

    case signUpActionTypes.sentCodeFailed:
      return {
        ...state,
        ...{
          sentCode: false,
        },
      };

    case signUpActionTypes.verifyCodeStart:
      return {
        ...state,
        ...{
          verified: false,
        },
      };

    case signUpActionTypes.verifyCodeSuccess:
      return {
        ...state,
        ...{
          verified: true,
          userInputtedCode: action.verifyCode,
        },
      };

    case signUpActionTypes.verifyCodeFailed:
      return {
        ...state,
        ...{
          verified: false,
        },
      };

    default:
      return state;
  }
};

export default SignupReducer;
